require('./userProfileService');
require('../fhApp/currentUser/currentUser');

"use strict";

angular.module('app.userProfile.userProfileController', [
    'app.currentUser',
    'app.userProfile.userProfileService',
])
    .controller('app.userProfile.userProfileController', [
        '$scope', 'username', '$state',
        'currentUser',
        'app.userProfile.userProfileService',
        function ($scope, username, $state, currentUser, userProfile) {
        	$scope.state = $state;
            $scope.username = username;
            $scope.enableFollowUser = currentUser.data.username !== username;

            userProfile.getFollow()
                .then((users)=> {
                    let user = _.find(users, { username: username });
                    $scope.ifollow = !!user.is_follower;
                });

            $scope.onToggleFollow = (userId) => {
                userProfile.toggleFollow(userId)
                .then((data)=> {
                    $scope.ifollow = data.following;
                });
            };

            if ($state.is('app.userProfile')) {
                $state.go('app.userProfile.feed');
            }
        }
    ]);



// WEBPACK FOOTER //
// ./app.v2/components/userProfile/userProfileController.js